import { render, staticRenderFns } from "./BuildingsShow.vue?vue&type=template&id=647d10ad"
import script from "./BuildingsShow.vue?vue&type=script&lang=js"
export * from "./BuildingsShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports